import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmReservationType } from "../../models/enums/ReservationType";

export type ReservationTypeSelectProps = {
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmReservationType[];
    defaultValue?: string | string[];
    maxTagCount?: number;
}


export const ReservationTypeSelect = (props: ReservationTypeSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let reservationTypes: { name: string; id: number }[] = props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmReservationType, props.specificTypes) : ObjectHelper.enumToObjectArray(enmReservationType);

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                onFocus={onFocus}
                maxTagCount={props.maxTagCount ?? undefined}
                value={props.value ? props.mode == "multiple" ? props.value as string[] : props.value as string : props.defaultValue}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseReservationType")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={reservationTypes?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id.toString()
                }))}
            />
        </>
    )
}